// assets
import { IconKey } from '@tabler/icons';

// constant
const icons = {
  IconKey
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const pages = {
  id: 'pages',
  title: 'AdminPage',
  caption: 'Management',
  type: 'group',
  roles: ["admin"],

  children: [
    {
      id: 'usermanagement',
      title: 'จัดการผู้ใช้งาน',
      type: 'item',
      url: '/admin',
      icon: icons.IconKey,
     // target: true
      breadcrumbs: false
    },
    {
      id: "senderrecipientmanagement",
      title: "จัดการชื่อผู้รับ/ส่ง",
      type: "item",
      url: "/ManageSenderRecipientNames",
      icon: icons.IconKey,
      // target: true
      breadcrumbs: false
    }
  ]
};
export default pages;
